import { render, staticRenderFns } from "./CustomersManagementRequests.vue?vue&type=template&id=0c64f79c"
import script from "./CustomersManagementRequests.vue?vue&type=script&lang=js"
export * from "./CustomersManagementRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports